import React, { Component } from 'react';
// @material-ui/core components
import { withStyles } from '@material-ui/core/styles';
// core components
import { Table, Button } from 'reactstrap';
import { connect } from 'react-redux';
import { compose } from 'redux';
import {
  getSubCategoryDetails,
  getAllCategory as getAllCategoryList,
  getCategory as getCategoryList,
  updateSubCategory,
  upload
} from '../../store/actions/vendor/Vendor';
import CardHeader from '../../components/Card/CardHeader.js';
import CardBody from '../../components/Card/CardBody.js';
import CardFooter from '../../components/Card/CardFooter.js';
import GridItem from '../../components/Grid/GridItem.js';
import GridContainer from '../../components/Grid/GridContainer.js';
import CustomInput from '../../components/CustomInput/CustomInput.js';

const styles = {
  typo: {
    paddingLeft: '25%',
    marginBottom: '40px',
    position: 'relative'
  },
  note: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    bottom: '10px',
    color: '#c0c1c2',
    display: 'block',
    fontWeight: '400',
    fontSize: '13px',
    lineHeight: '13px',
    left: '0',
    marginLeft: '20px',
    position: 'absolute',
    width: '260px'
  },
  cardCategoryWhite: {
    color: 'rgba(255,255,255,.62)',
    margin: '0',
    fontSize: '14px',
    marginTop: '0',
    marginBottom: '0'
  },
  cardTitleWhite: {
    color: '#FFFFFF',
    marginTop: '0px',
    minHeight: 'auto',
    fontWeight: '300',
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: '3px',
    textDecoration: 'none'
  }
};

class SubCategoryEdit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      imageUploadMessage: '',
      subCategoryDetail: {
        name: 'loading..',
        superCategoryId: '63c0eeb0-206b-11eb-97d7-7dadae6d1a71',
        categoryId: '63c0eeb0-206b-11eb-97d7-7dadae6d1a71',
        subCategoryId: '63c0eeb0-206b-11eb-97d7-7dadae6d1a71',
        icon: 'https://inolemit.sirv.com/utils/35%20(1).gif'
      }
    };
  }

  componentDidMount() {
    var superCategoryId = this.props.match.params.superCategoryId;
    var categoryId = this.props.match.params.categoryId;
    var subCategoryId = this.props.match.params.subCategoryId;
    this.props.getSubCategoryDetails(categoryId, subCategoryId);
    this.props.getAllCategoryList(superCategoryId);
    this.props.getCategoryList(superCategoryId);
    this.getDetails(
      this.props.match.params.superCategoryId,
      this.props.match.params.categoryId,
      this.props.match.params.subCategoryId
    );
  }

  getDetails = (superCategoryId, categoryId, subCategoryId) => {
    if (this.props.subCategoryDetails !== undefined) {
      setTimeout(() => {
        this.setState((prevState) => ({
          subCategoryDetail: {
            ...prevState.subCategoryDetail,
            superCategoryId: this.props.subCategoryDetails.superCategoryId,
            subCategoryId: this.props.subCategoryDetails.id,
            categoryId: this.props.subCategoryDetails.categoryId,
            name: this.props.subCategoryDetails.name,
            icon: this.props.subCategoryDetails.icon
          }
        }));
      }, 7000);
    } else {
      setTimeout(() => {
        this.setState((prevState) => ({
          subCategoryDetail: {
            ...prevState.subCategoryDetail,
            superCategoryId: this.props.subCategoryDetails.superCategoryId,
            subCategoryId: this.props.subCategoryDetails.id,
            categoryId: this.props.subCategoryDetails.categoryId,
            name: this.props.subCategoryDetails.name,
            icon: this.props.subCategoryDetails.icon
          }
        }));
      }, 7000);
    }
  };

  onChange = (event) => {
    let subCategoryDetail = this.state.subCategoryDetail;
    subCategoryDetail[event.target.name] = event.target.value;

    this.setState({
      subCategoryDetail
    });
  };
  onChangeSelect = (event) => {
    let subCategoryDetail = this.state.subCategoryDetail;
    subCategoryDetail[event.target.name] = event.target.value;

    this.setState({
      subCategoryDetail
    });
  };
  onUpload = (event) => {
    this.setState({
      imageUploadMessage: 'Uploading the file, please wait...'
    });

    let data = new FormData();
    data.append('files', event.target.files[0]);

    // Upload image
    this.props
      .upload(data)
      .then((response) => {
        if (response.status === 201) {
          this.setState({
            imageUploadMessage: 'File uploaded successfully.'
          });
          let subCategoryDetail = this.state.subCategoryDetail;
          subCategoryDetail.icon = `${response.data.uploads[0].path}`;
          this.setState({
            subCategoryDetail
          });
        } else {
          this.setState({
            imageUploadMessage: 'Please, try Again'
          });
        }
      })
      .catch((error) => {
        this.setState({
          imageUploadMessage:
            'An error occurred while executing the query. Please try Again'
        });
      })
      .then(() => {
        console.log('Image uploaded');
      });
  };
  onSubmit = (event) => {
    event.preventDefault();
    // Update CategoryDetail
    this.props.updateSubCategory(this.state.subCategoryDetail);
    setTimeout(() => {
      this.props.history.push(
        `/vendor/sub-category/${this.state.subCategoryDetail.superCategoryId}/${this.state.subCategoryDetail.categoryId}`
      );
    }, 3000);
  };

  render() {
    const { classes } = this.props;
    return (
      <>
        <CardHeader color="primary">
          <h4 className={classes.cardTitleWhite}>Update a SubCategory</h4>
          <p className={classes.cardCategoryWhite}>
            When choosing icon, PNG images would be better over JPG or imap
          </p>
        </CardHeader>
        <CardBody>
          <br />
          <GridContainer>
            <GridItem xs={12} sm={12} md={3}>
              <CustomInput
                labelText="SubCategory Name"
                value={this.state.subCategoryDetail.name}
                onChange={this.onChange}
                name="name"
                id="name"
                formControlProps={{
                  fullWidth: true
                }}
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <CustomInput
                labelText="Category Icon"
                id="icon"
                type="file"
                name="icon"
                accept="image/png, image/jpeg, image/jpg"
                onChange={this.onUpload}
                formControlProps={{
                  fullWidth: true
                }}
              />
            </GridItem>
            <br />
            <p style={{ color: '#000' }}>{this.state.imageUploadMessage}</p>
          </GridContainer>
        </CardBody>
        <CardFooter>
          <Button
            type="submit"
            onClick={this.onSubmit}
            style={{
              color: '#fff',
              backgroundColor: '#9c27b0',
              boxShadow:
                '0 2px 2px 0 rgba(156, 39, 176, 0.14), 0 3px 1px -2px rgba(156, 39, 176, 0.2), 0 1px 5px 0 rgba(156, 39, 176, 0.12)'
            }}
          >
            Update SubCategory
          </Button>
        </CardFooter>
        <br /> <br />
        <Table hover>
          <thead>
            <tr>
              <th>#</th>
              <th>Name</th>
              <th>Super Category</th>
              <th>Icon</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>1</th>
              <td>{this.state.subCategoryDetail.name}</td>
              {this.props.superCategories
                .filter(
                  (categorieFilter) =>
                    categorieFilter.id ===
                    this.state.subCategoryDetail.superCategoryId
                )
                .map((type) => (
                  <td key={type.id}>{type.name}</td>
                ))}
              {this.props.categories
                .filter(
                  (categorieFilter2) =>
                    categorieFilter2.id ===
                    this.state.subCategoryDetail.categoryId
                )
                .map((type2) => (
                  <td key={type2.id}>{type2.name}</td>
                ))}
              <td>
                <img
                  src={this.state.subCategoryDetail.icon}
                  style={{ height: '70px' }}
                  alt=""
                />
              </td>
            </tr>
          </tbody>
        </Table>
      </>
    );
  }
}

const mapStateWithProps = (state) => ({
  subCategoryDetails: state.vendor.subCategoryDetails,
  categories: state.vendor.categories,
  superCategories: state.vendor.superCategories
});
const mapDispatchWithProps = (dispatch) => {
  return {
    getCategoryList: () => dispatch(getCategoryList()),
    getAllCategoryList: (superCategoryId) =>
      dispatch(getAllCategoryList(superCategoryId)),
    getSubCategoryDetails: (categoryId, subCategoryId) =>
      dispatch(getSubCategoryDetails(categoryId, subCategoryId)),
    updateSubCategory: (categoryData) =>
      dispatch(updateSubCategory(categoryData)),
    upload: (data) => dispatch(upload(data))
  };
};

export default compose(
  connect(mapStateWithProps, mapDispatchWithProps),
  withStyles(styles)
)(SubCategoryEdit);
